// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetDataItemByIdRequestModel from '../../model/get-data-item-by-id-request-model';
import UpdateDataItemRequestModel from '../../model/update-data-item-request-model';
import DeleteDataItemRequestModel from '../../model/delete-data-item-request-model';
import GetDataItemPagedListRequestModel from '../../model/get-data-item-paged-list-request-model';
import CreateDataItemRequestModel from '../../model/create-data-item-request-model';
import GetTagsByDataItemIdRequestModel from '../../model/get-tags-by-data-item-id-request-model';
import AddTagToDataItemRequestModel from '../../model/add-tag-to-data-item-request-model';
import RemoveTagFromDataItemRequestModel from '../../model/remove-tag-from-data-item-request-model';
import DataItemModel from '../../model/data-item-model';
import DataItemListPagingResultModel from '../../model/data-item-list-paging-result-model';
import LearnitTagListResultModel from '../../model/learnit-tag-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getDataItemById(request: GetDataItemByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetDataItemByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-data-item-by-id'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DataItemModel.toModel(dto));
  },
  /**  */
  async updateDataItem(request: UpdateDataItemRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateDataItemRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-data-item'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        creatorId: requestDTO.creatorId,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modified: requestDTO.modified,
        title: requestDTO.title,
        subTitle: requestDTO.subTitle,
        comment: requestDTO.comment,
        pictureDocumentExternalId: requestDTO.pictureDocumentExternalId,
        statusId: requestDTO.statusId,
        validFrom: requestDTO.validFrom,
        validUntil: requestDTO.validUntil,
        contentTypeId: requestDTO.contentTypeId,
        contentTypeUrl: requestDTO.contentTypeUrl,
        contentTypePath: requestDTO.contentTypePath,
        categoryId: requestDTO.categoryId,
        searchTerms: requestDTO.searchTerms,
        relatedLinkUrl: requestDTO.relatedLinkUrl,
        relatedLinkText: requestDTO.relatedLinkText,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async deleteDataItem(request: DeleteDataItemRequestModel, config?: RequestConfig) {
    const requestDTO = DeleteDataItemRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-data-item'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getDataItemPagedList(request: GetDataItemPagedListRequestModel, config?: RequestConfig) {
    const requestDTO = GetDataItemPagedListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-data-item-paged-list'] ?? 'Learnit/DataItems';
    const response = await service.get<any>(endpointPath, {
      query: {
        categories: requestDTO.categories,
        tags: requestDTO.tags,
        contentType: requestDTO.contentType,
        contentStatus: requestDTO.contentStatus,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DataItemListPagingResultModel.toModel(dto));
  },
  /**  */
  async createDataItem(request: CreateDataItemRequestModel, config?: RequestConfig) {
    const requestDTO = CreateDataItemRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-data-item'] ?? 'Learnit/DataItems';
    const response = await service.post<any>(endpointPath, {
      body: {
        title: requestDTO.title,
        subTitle: requestDTO.subTitle,
        comment: requestDTO.comment,
        pictureDocumentExternalId: requestDTO.pictureDocumentExternalId,
        statusId: requestDTO.statusId,
        validFrom: requestDTO.validFrom,
        validUntil: requestDTO.validUntil,
        contentTypeId: requestDTO.contentTypeId,
        contentTypeUrl: requestDTO.contentTypeUrl,
        contentTypePath: requestDTO.contentTypePath,
        categoryId: requestDTO.categoryId,
        searchTerms: requestDTO.searchTerms,
        relatedLinkUrl: requestDTO.relatedLinkUrl,
        relatedLinkText: requestDTO.relatedLinkText,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getTagsByDataItemId(request: GetTagsByDataItemIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetTagsByDataItemIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-tags-by-data-item-id'] ?? 'Learnit/DataItems/{id}/Tags';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(LearnitTagListResultModel.toModel(dto));
  },
  /**  */
  async addTagToDataItem(request: AddTagToDataItemRequestModel, config?: RequestConfig) {
    const requestDTO = AddTagToDataItemRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-add-tag-to-data-item'] ?? 'Learnit/DataItems/{id}/AddTag/{tagId}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    endpointPath = endpointPath.replace(/\{tagId\}/g, `${requestDTO.tagId}`);
    const response = await service.post<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async removeTagFromDataItem(request: RemoveTagFromDataItemRequestModel, config?: RequestConfig) {
    const requestDTO = RemoveTagFromDataItemRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-remove-tag-from-data-item'] ?? 'Learnit/DataItems/{id}/RemoveTag/{tagId}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    endpointPath = endpointPath.replace(/\{tagId\}/g, `${requestDTO.tagId}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
